window.$ = window.jQuery;

//Googleフォント
window.WebFontConfig = {
  // 以下にフォントを指定する
  google: { families: ['Noto+Sans+JP:300,400,500,700', 'Noto+Serif+JP:400,500,600,700'] },
  active: function () {
    sessionStorage.fonts = true;
  }
};

(function () {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();

//object-fit
objectFitImages('img.object_fit');

//ヘッダー
$(function(){
  var common_header = $(".common-header");
  var header_toggle = $(".common-header__toggle");
  var header_close = $(".common-header__close");
  var header_overlay = $(".common-header__overlay");
  var header_nav = $(".common-header__nav");
  var sub_toggle = $(".sub_toggle");
  var sub_menu = $(".sub_menu");
  header_toggle.on("click",function(){
    common_header.addClass("is-open");
    header_nav.addClass("is-open");
    header_overlay.fadeIn(1000);
  })
  header_close.add(header_overlay).on("click",function(){
    common_header.removeClass("is-open");
    header_nav.removeClass("is-open");
    header_overlay.fadeOut(1000);
  })
  sub_toggle.on("click",function(){
    $(this).toggleClass("is-open");
    sub_menu.slideToggle();
  })
});

//main上部余白調整 & KV
$(window).on("load",function(){
  var window_height = $(window).height();
  var header_height = $("header").innerHeight();
  $("body").css("opacity","1");
  $(".top-kv").height(window_height);
});
$(window).on("resize",function(){
  var window_height = $(window).height();
  var header_height = $("header").innerHeight();
  $(".top-kv").height(window_height);
});

//共通アニメーション
$(window).on("load",function(){
  var window_height = $(window).innerHeight();
  var main_height = $("main").innerHeight();
  var footer_height = $("footer").innerHeight();
  //ヘッダー
  if($("body").hasClass("template-index") || $("body").hasClass("template-page") || $("body").hasClass("template-collection") || $("body").hasClass("template-blog")){
  ScrollTrigger.create({
    trigger: '.header_color_toggle',
    start: 'top top',
    end: main_height,
    toggleClass: {targets: ".common-header", className: "is-red"},
    //markers: true,
  });
  }
  //サイドヘッダー
  ScrollTrigger.create({
    trigger: '.common-side__trigger',
    pin: '.common-side',
    pinSpacing: false,
    start: "top top",
    end: main_height - footer_height,
    //markers: true,
  })
  //見出しアニメーション
  ScrollTrigger.batch(".common-heading",{
    onEnter: (elements, triggers) => {
      $(elements).addClass("is-active");
    },
    start: 'top 60%',
    once:true,
    //markers: true,
    }
  );
  if($("body").hasClass("template-index")){
    var main_height = $("main").innerHeight();
    var window_height = $(window).innerHeight();
    ScrollTrigger.create({
      trigger: '.top-about',
      start: 'center center',
      end: main_height - window_height,
      toggleClass: {targets: ".common-fixedSns", className: "is-active"},
      //markers: true,
    });
  } else {
    var main_height = $("main").innerHeight();
    var window_height = $(window).innerHeight();
    ScrollTrigger.create({
      trigger: 'main',
      start: 'top top',
      end: main_height - window_height,
      toggleClass: {targets: ".common-fixedSns", className: "is-active"},
      //markers: true,
    });
  }
  //フェードアップ
  ScrollTrigger.batch(".common-fade__up",{
    onEnter: (elements, triggers) => {
      $(elements).addClass("is-active");
    },
    start: 'top 65%',
    once:true
    }
  );
});
/* ScrollTrigger.create({
  trigger: 'footer',
  start: 'top bottom',
  toggleClass: {targets: ".common-fixedSns", className: "is-active"},
  once: true,
  markers: true,
}); */


//アコーディオン
$(function(){
  $('.accordion-label').each(function(){
		$(this).on('click',function(){
			$(this).toggleClass('open');
			$("+.accordion-cont",this).stop().slideToggle();
			return false;
		});
  });
});

//ページトップに戻る
$(window).on("load",function(){
  var pagetop = $('.common-pageTop');
  var main_height = $("main").innerHeight();
  var window_height = $(window).innerHeight();
  var footer_height = $("footer").innerHeight();
  pagetop.hide();

  $(window).scroll(function () {
    var scroll = $(window).scrollTop() + $(window).height();
    var footer = $("footer").offset().top;
    var absoluteBottom = $("footer").outerHeight();
    if ($(this).scrollTop() > window_height) {
      pagetop.fadeIn();
    } else {
      pagetop.fadeOut();
    }
    if (scroll >= footer) {
      pagetop.css({
        "position": "absolute",
      }).addClass("is-stop");
    } else {
      pagetop.css({
        "position": "fixed",
      }).removeClass("is-stop");
    }
  });
  pagetop.click(function () {
    $('body, html').animate({ scrollTop: 0 }, 500);
    return false;
  });
});

//スムーズスクロール
$(function () {
  $('.section-diagnose__btn[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "body" : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, 700, "swing");
    return false;
  });
});

//カートアイコン
let cart_icon_bubble = $("#cart-icon-bubble");
let cart_icon_bubble02 = $("#cart-icon-bubble02");
let cart_icon_bubble03 = $("#cart-icon-bubble03");

var observer = new MutationObserver(function(){
  observer.disconnect();
  bubble_number = cart_icon_bubble.find(".cart-count-bubble").find("span[aria-hidden]").text();
  if(bubble_number >= 0 && cart_icon_bubble02.find(".cart-count-bubble").length == 0){
    cart_icon_bubble02.add(cart_icon_bubble03).append('<div class="cart-count-bubble"><span aria-hidden="true"></span><span class="visually-hidden">1個のアイテム</span></div>');
  }
  cart_icon_bubble02.add(cart_icon_bubble03).find(".cart-count-bubble").find("span[aria-hidden]").text(bubble_number);
  if(bubble_number.length <= 0){
    $(".cart-count-bubble").remove();
  }
  observer.observe(elem, config);
});
const elem = document.getElementById('cart-icon-bubble');
const config = {
  attributes: true,
  childList: true,
  subtree: true,
  characterData: true
};
observer.observe(elem, config);

//アカウント
if($("body").hasClass("template-customers-addresses")){
  $('button[aria-controls="AddAddress"]').on("click",function(){
    $("#AddAddress").toggleClass("is-active");
  })
}
